// extracted by mini-css-extract-plugin
export default {"imgCenter":"style_imgCenter__lGZSa","sliderBox":"style_sliderBox__sFmo6","SliderText":"style_SliderText__3hR4h","itemLink":"style_itemLink__e6D6D"};